import React from "react";
import { motion } from "framer-motion";

function GraphicDesignFeatures() {
  const features = [
    {
      title: "Logo & Brand Identity Design",
      description:
        "Create a memorable brand identity with unique logos, typography, and color schemes that capture your business personality.",
      color: "#1E88E5",
    },
    {
      title: "Marketing & Promotional Materials",
      description:
        "Design impactful brochures, flyers, posters, and business cards that effectively communicate your brand message.",
      color: "#43A047",
    },
    {
      title: "Social Media Graphics",
      description:
        "Engage audiences with eye-catching visuals optimized for platforms like Instagram, Facebook, LinkedIn, and Twitter.",
      color: "#FB8C00",
    },
    {
      title: "Website & UI/UX Design",
      description:
        "Deliver seamless user experiences with visually appealing, responsive website and app designs tailored to your audience.",
      color: "#8E24AA",
    },
    {
      title: "Packaging Design",
      description:
        "Stand out on shelves with creative, functional, and brand-consistent packaging that attracts customers at first glance.",
      color: "#00ACC1",
    },
    {
      title: "Infographics & Visual Storytelling",
      description:
        "Simplify complex information with beautifully designed infographics that are easy to understand and share.",
      color: "#F4511E",
    },
  ];

  // Smooth animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.35,
        duration: 1,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeInOut" },
    },
  };

  const styles = {
    container: {
      padding: "60px 20px",
      textAlign: "center",
      background: "#f8f9fa",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    heading: {
      fontSize: "32px",
      marginBottom: "40px",
      fontWeight: "bold",
      letterSpacing: "0px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "25px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    card: {
      background: "#fff",
      borderRadius: "10px",
      boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
      padding: "25px",
      textAlign: "left",
      transition: "all 0.3s ease",
      borderLeft: "8px solid transparent",
      minHeight: "200px",
      cursor: "pointer",
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "15px",
      color: "#1e40af",
    },
    desc: {
      fontSize: "15px",
      lineHeight: "1.6",
      textAlign: "justify",
      color: "#4b5563",
    },
  };

  return (
    <div style={styles.container}>
      <motion.h2
        style={styles.heading}
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        Key Features of Our Graphic Design Solutions
      </motion.h2>

      <motion.div
        style={styles.grid}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {features.map((feature, index) => (
          <motion.div
            key={index}
            variants={cardVariants}
            style={{
              ...styles.card,
              borderLeft: `8px solid ${feature.color}`,
            }}
            whileHover={{
              scale: 1.05,
              boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
            }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            <h3 style={styles.title}>{feature.title}</h3>
            <p style={styles.desc}>{feature.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}

export default GraphicDesignFeatures;
